export const INLINE_ICON_IMAGE_CLASS = "spf-inline-icon-image";

export const INLINE_ICON_SIZE_PX = {
  S: 16,
  M: 32,
  L: 64,
  XL: 128,
} as const;

export type InlineIconSizeCode = keyof typeof INLINE_ICON_SIZE_PX;

export const DEFAULT_INLINE_ICON_SIZE_CODE: InlineIconSizeCode = "S";

export type InlineIconConfig = {
  name: string;
  url: string;
  alt?: string;
  description?: string;
  iconLibrary?: string;
  size?: string | number;
  cssClass?: string;
};
